import React, { useEffect, useReducer, useRef } from 'react';

import ActionButton from '../components/builder/ActionButton';
import { DynamicForm } from '../components/builder/DynamicForm';
import Input from '../components/builder/Input';
import ClaimPromoFull from './ClaimPromoFull';

const ClaimPrize = ({ promotion_id, ...props }) => {
	const [ state, dispatch ] = useReducer(( state, action ) => {
		switch(action.type) {
			case 'NO_PRIZES':
				return { ...state, status:'no_prize' };

			case 'CHECKING':
				return { ...state, status:'checking' };

			case 'MAIL_SENT':
				return { ...state, status:'mail_sent' };

			case 'SET_PRIZES':
				return { ...state, prizes:action.prizes, status:'prize_list' };
		
			case 'CLAIM_FORM':
				return { ...state, prize:action.prize, status:'claim_form' };

			case 'SET_USER_FORM':
				let new_form = {...state.form,...action.user};
				for(var i in new_form) {
					if(new_form[i] == '') delete new_form[i];
				}
				return { ...state, form:new_form, is_valid:action.is_valid };

			case 'TOGGLE_ERRORS':
				return { ...state, showFormErrors:!state.showFormErrors };

			case 'SET_CLAIMED':
				return {
					...state,
					status:'prize_list',
					prize:null,
					prizes:state.prizes.map((prize) => {
						if(prize.Prize.id != action.id) return prize;
						const timeElapsed = Date.now();
						const today = new Date(timeElapsed).toDateString();
						return { ...prize, PromoClaim:{ created:today }};
					}),
				};
			
			default:
				return state;
		}
	}, {
		status:'landing',
		prizes:[],
		prize:null,
		form:null,
		showFormErrors:false,
		is_valid:false
	});

	const email = useRef('');

	useEffect(() => {
		if(props.login_id == 0) return;
		dispatch({ type:'CHECKING' });

		let data = {};
		if(props.ct != '') {
			data.ct = props.ct;
			data.lid = props.login_id;
		}
		$.post(`/promotions/check_claim/${promotion_id}`, data, (response) => {
			if(response.reason != undefined) {
				switch(response.reason) {
					case 'no_prize':
						dispatch({type:'NO_PRIZES'});
						return;

					default:
						break;
				}
			}

			if(response.prizes) {
				dispatch({ type:'SET_PRIZES', prizes:response.prizes });
			}
		}, 'JSON');
	}, [ props.login_id ]);

	const claimForm = (prize) => {
		dispatch({type:'CLAIM_FORM',prize})
	};

	const userForm = (user, is_valid) => {
		dispatch({type:'SET_USER_FORM',user,is_valid})
	};

	const claimToken = () => {
		$.post(`/promotions/claim_token/${promotion_id}`, { email:email.current });

		dispatch({type:'MAIL_SENT'});
	}
	
	const submitClaim = () => {
		if(!state.is_valid) {
			dispatch({ type:'TOGGLE_ERRORS' })
			return;
		}

		let data = {
			claim:JSON.stringify(state.form),
			prize_id:state.prize.Prize.id,
		};

		if(props.ct != '') {
			data.ct = props.ct;
			data.lid = props.login_id;
		}

		$.post(`/promotions/claim_prize/${promotion_id}`, data, (response) => {
			dispatch({ type:'SET_CLAIMED', id:state.prize.Prize.id });
		}, 'JSON');
	};

	return (
		<div>
			{(state.status == 'landing') && (
				<div>
					<h2>Enter your email in order to check your prizes</h2>

					<Input
						change={(k,v)=>{email.current = v}}
					>Email</Input>

					<ActionButton
						onClick={claimToken}
					>Check</ActionButton>
				</div>
			)}

			{(state.status == 'mail_sent') && (
				<div>
					<h2>Check your inbox for an email with a link to check your prizes</h2>
				</div>
			)}

			{(state.status == 'checking') && (
				<div>
					<h2>Checking if you've won a prize...</h2>
				</div>
			)}

			{(state.status == 'no_prize') && (
				<div>
					<h2>Better luck next time, You've won no prize</h2>
				</div>
			)}

			{(state.status == 'prize_list') && (
				<div>
					<h2>Congratulations!</h2>

					<div className="gui_flex">
						{state.prizes.map((prize) => (
							<div style={{marginBottom:'1rem',borderBottom:'1px solid black'}}>
								{prize.PrizeType.title}
								<p>
									{prize.PrizeType.description}
								</p>
								Won on: {prize.Prize.created_format}

								{prize.PromoClaim == undefined && (
									<ActionButton
										onClick={() => claimForm(prize)}
									>Claim</ActionButton>
								)}

								{prize.PromoClaim != undefined && (
									<div style={{ color:'red' }}>Prize already claimed on {prize.PromoClaim.created}</div>
								)}
							</div>
						))}
					</div>
				</div>
			)}

			{(state.status == 'claim_form') && (
				<div>
					<ClaimPromoFull 
						prize_id={state.prize.Prize.id}
						prize_type={state.prize.PrizeType}
						claim={{}}
						back={() => {}}
					/>
				</div>
			)}
		</div>
	)
};

export default ClaimPrize;